import Button from "components/Button";

interface AppFooterButtonProps {
  icon: React.ReactNode;
  href: string;
  isActive?: boolean;
  children: React.ReactNode;
}

const AppFooterButton = ({
  icon,
  href,
  isActive,
  children,
}: AppFooterButtonProps) => (
  <Button
    variant="tertiary"
    size="small"
    icon={icon}
    href={href}
    state={isActive ? "active" : "default"}
  >
    {children}
  </Button>
);

export default AppFooterButton;
